import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79af4ca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Sources")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Loading sources")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Error loading sources")
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 3 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ingested Files:", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 4,
  class: "files"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " A listing of all data that Monarch archives for use in its knowledge graph and tools: ", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Note about licensing")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Each of these sources has its own license. We have described this licensing challenge extensively on ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("reusabledata.org")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" and our ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("2018 PlosOne publication")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(". Many of the specific data resources we use in Monarch have been evaluated according to our reusabledata.org rubric; see the ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("corpus of evaluations here")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(". ")

import { ref, computed, onMounted } from "vue";
import AppCheckbox from "@/components/AppCheckbox.vue";
import AppAccordion from "@/components/AppAccordion.vue";
import { getDatasets } from "@/api/datasets";
import { getOntologies } from "@/api/ontologies";
import { Source } from "@/api/source";
import { breakUrl } from "@/util/string";
import { useQuery } from "@/util/composables";

/** whether to show dataset sources */

export default /*#__PURE__*/_defineComponent({
  __name: 'PageSources',
  setup(__props) {

const showDatasets = ref(true);
/** whether to show ontology sources */
const showOntologies = ref(true);

/** get source img src */
function getSrc(image = "") {
  try {
    if (image.startsWith("http")) return image;
    else return require(`@/assets/sources/${image}`);
  } catch (error) {
    return "";
  }
}

/** get filename from full path */
function getFilename(path = "") {
  return path
    .split("/")
    .filter((part) => part)
    .pop();
}

const {
  query: getSources,
  data: sources,
  isLoading,
  isError,
} = useQuery(async function () {
  /** get sources from apis */
  const datasets = await getDatasets();
  const ontologies = await getOntologies();

  /** combine sources */
  const sources = [...datasets, ...ontologies];

  /** sort sources alphabetically by name or id */
  sources.sort((a: Source, b: Source) => {
    if (
      (a?.name || a?.id || "").toLowerCase() <
      (b?.name || b?.id || "").toLowerCase()
    )
      return -1;
    else return 1;
  });

  return sources;
}, []);

onMounted(getSources);

/** shown sources */
const filteredSources = computed(
  (): Array<Source> =>
    sources.value.filter(
      (source: Source) =>
        (source.type === "dataset" && showDatasets.value) ||
        (source.type === "ontology" && showOntologies.value)
    )
);

/** number of dataset sources */
const datasetCount = computed(
  (): number =>
    sources.value.filter((source) => source.type === "dataset").length
);

/** number of ontology sources */
const ontologyCount = computed(
  (): number =>
    sources.value.filter((source) => source.type === "ontology").length
);

return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_AppStatus = _resolveComponent("AppStatus")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppMarkdown = _resolveComponent("AppMarkdown")!
  const _component_AppLink = _resolveComponent("AppLink")!
  const _component_AppSection = _resolveComponent("AppSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_AppFlex, null, {
          default: _withCtx(() => [
            _createVNode(AppCheckbox, {
              modelValue: showDatasets.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showDatasets).value = $event)),
              text: `Datasets (${_unref(datasetCount)})`,
              icon: "database"
            }, null, 8, ["modelValue", "text"]),
            _createVNode(AppCheckbox, {
              modelValue: showOntologies.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showOntologies).value = $event)),
              text: `Ontologies (${_unref(ontologyCount)})`,
              icon: "puzzle-piece"
            }, null, 8, ["modelValue", "text"])
          ]),
          _: 1
        }),
        (_unref(isLoading))
          ? (_openBlock(), _createBlock(_component_AppStatus, {
              key: 0,
              code: "loading"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isError))
          ? (_openBlock(), _createBlock(_component_AppStatus, {
              key: 1,
              code: "error"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_AppFlex, { direction: "col" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredSources), (source, sourceIndex) => {
              return (_openBlock(), _createBlock(AppAccordion, {
                key: sourceIndex,
                text: source.name || source.id || '',
                icon: source.type === 'dataset' ? 'database' : 'puzzle-piece'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppFlex, null, {
                    default: _withCtx(() => [
                      (source.link)
                        ? _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
                            key: 0,
                            design: "small",
                            icon: "home",
                            text: "Home",
                            to: source.link
                          }, null, 8, ["to"])), [
                            [_directive_tooltip, 'Homepage or repository for this source']
                          ])
                        : _createCommentVNode("", true),
                      (source.license)
                        ? _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
                            key: 1,
                            design: "small",
                            icon: "balance-scale",
                            text: "License",
                            to: source.license
                          }, null, 8, ["to"])), [
                            [_directive_tooltip, 'Link to licensing information for this source']
                          ])
                        : _createCommentVNode("", true),
                      (source.distribution)
                        ? _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
                            key: 2,
                            design: "small",
                            icon: "download",
                            text: "RDF",
                            to: source.distribution
                          }, null, 8, ["to"])), [
                            [_directive_tooltip, 'Download Resource Description Framework file']
                          ])
                        : _createCommentVNode("", true),
                      (source.date)
                        ? _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
                            key: 3,
                            design: "small",
                            color: "secondary",
                            icon: "calendar-alt",
                            text: source.date
                          }, null, 8, ["text"])), [
                            [_directive_tooltip, 'Date when this source was ingested into Monarch']
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  (getSrc(source.image))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "image",
                        src: getSrc(source.image),
                        alt: source.name
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  (source.description)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        innerHTML: source.description
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (source.usage)
                    ? (_openBlock(), _createBlock(_component_AppMarkdown, {
                        key: 2,
                        source: source.usage,
                        component: "p"
                      }, null, 8, ["source"]))
                    : _createCommentVNode("", true),
                  (source.files?.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _hoisted_8))
                    : _createCommentVNode("", true),
                  (source.files?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(source.files, (file, fileIndex) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_AppLink, {
                            key: fileIndex,
                            to: file,
                            class: "truncate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(getFilename(file)), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])), [
                            [_directive_tooltip, _unref(breakUrl)(file)]
                          ])
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["text", "icon"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _hoisted_10,
        _createVNode(_component_AppButton, {
          icon: "download",
          text: "All Downloads",
          to: "https://archive.monarchinitiative.org/latest/"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createElementVNode("p", null, [
          _hoisted_12,
          _createVNode(_component_AppLink, { to: "https://reusabledata.org/" }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _hoisted_14,
          _createVNode(_component_AppLink, { to: "https://doi.org/10.1371/journal.pone.0213090" }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _hoisted_16,
          _createVNode(_component_AppLink, { to: "https://reusabledata.org/#our-sources-data" }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _hoisted_18
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})